import Environment from '@di-shared/features/environment/Environment';
import {Dispatch, SetStateAction} from 'react';
import Eu from '@di-shared/features/history/driving-info/DrivingInfoHeader/.eu';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoHeader/.kr';

export interface DrivingInfoHeaderProps {
  vin: string;
  selectedDate: Date;
  setSelectedDate: Dispatch<SetStateAction<Date>>;

  changeMonth(date: Date): void;
}

export default function DrivingInfoHeader({vin, selectedDate, setSelectedDate, changeMonth}: DrivingInfoHeaderProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          changeMonth={changeMonth}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          changeMonth={changeMonth}
        />
      </Environment.Kr>
    </>
  );
}
